import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ModuleSlide } from '@/hooks/useEducation';

interface SlideViewerProps {
  slide: ModuleSlide;
  slideNumber: number;
  totalSlides: number;
}

export const SlideViewer: React.FC<SlideViewerProps> = ({ 
  slide, 
  slideNumber, 
  totalSlides 
}) => {
  return (
    <Card className="min-h-[400px]">
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle className="text-2xl">{slide.title}</CardTitle>
          <div className="text-sm text-muted-foreground">
            {slideNumber} / {totalSlides}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div 
          className="prose prose-lg max-w-none dark:prose-invert"
          dangerouslySetInnerHTML={{ __html: slide.content || '' }}
        />
      </CardContent>
    </Card>
  );
};